import PerformancePaymentPlans from './PerformancePaymentPlans'

export default PerformancePaymentPlans
